import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/doctorlist'
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/doctorlist',
                    component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/doctor/Doctorlist.vue'),
                    meta: { title: '医生列表' }
                },
                {
                    path: '/doctorreviewlist',
                    component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/doctor/Doctorreviewlist.vue'),
                    meta: { title: '审核列表' }
                },
                {
                    path: '/quickreplylist',
                    component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/doctor/Quickreplylist.vue'),
                    meta: { title: '快捷回复列表' }
                },
                {
                    path: '/studioslist',
                    component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/studio/studiolist.vue'),
                    meta: { title: '工作室列表' }
                },
                {
                    path: '/404',
                    component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
                    meta: { title: '403' }
                }
            ]
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: { title: '登录' }
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
